import { GetAppOutlined } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

type IncExportButtonTypes = { label?: string } & ButtonProps;

const IncExportButton = ({ label, ...rest }: IncExportButtonTypes) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="text"
      startIcon={<GetAppOutlined />}
      sx={{ whiteSpace: 'nowrap' }}
      {...rest}
    >
      {label ?? t('incExportButton.label')}
    </Button>
  );
};

export default IncExportButton;
